import {
  styled,
  Select,
  MenuItem,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSearchParams } from "react-router-dom";

const PaginationRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
}));

const CustomPagination = ({ total, perPageOptions = [5, 10, 20, 50, 100] }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get("page") ?? 0);
  const size = Number(searchParams.get("size") ?? 10);

  const start = total === 0 ? 0 : page * size + 1;
  const end = Math.min((page + 1) * size, total);

  const canGoPrev = page > 0;
  const canGoNext = (page + 1) * size < total;

  const updateParams = (newPage, newSize = size) => {
    setSearchParams((prev) => {
      prev.set("page", String(newPage));
      prev.set("size", String(newSize));
      return prev;
    });
  };

  const handlePrev = () => {
    if (!canGoPrev) return;
    updateParams(page - 1);
  };

  const handleNext = () => {
    if (!canGoNext) return;
    updateParams(page + 1);
  };

  const handleSizeChange = (e) => {
    updateParams(0, Number(e.target.value));
  };

  return (
    <PaginationRoot>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Items per page:
        </Typography>
        <Select
          value={size}
          onChange={handleSizeChange}
          size="small"
          variant="standard"
          disableUnderline
          sx={{ fontSize: "0.875rem" }}
        >
          {perPageOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {start} - {end} of {total}
        </Typography>
        <IconButton size="small" onClick={handlePrev} disabled={!canGoPrev}>
          <ChevronLeftIcon size={16} />
        </IconButton>
        <IconButton size="small" onClick={handleNext} disabled={!canGoNext}>
          <ChevronRightIcon size={16} />
        </IconButton>
      </Box>
    </PaginationRoot>
  );
};

export default CustomPagination;
